(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azelia-compose-set"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-compose-set]');
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
    sections.forEach((section) => {
      const inputs = [...section.querySelectorAll('[data-compose-item]')];
      const total = section.querySelector('[data-compose-total]');
      const button = section.querySelector('[data-compose-submit]');
      const status = section.querySelector('[data-compose-status]');
      const update = () => {
        const selected = inputs.filter((input) => input.checked && !input.disabled);
        total.textContent = formatMoney(selected.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0));
        button.disabled = selected.length === 0;
      };
      inputs.forEach((input) => input.addEventListener('change', update));
      button.addEventListener('click', () => {
        const items = inputs.filter((input) => input.checked && !input.disabled).map((input) => ({ id: Number(input.value), quantity: 1 }));
        if (!items.length) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = 'Ajout de votre sélection…';
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        form.hidden = true;
        items.forEach((item, index) => {
          const id = document.createElement('input');
          id.type = 'hidden';
          id.name = `items[${index}][id]`;
          id.value = String(item.id);
          form.appendChild(id);
          const quantity = document.createElement('input');
          quantity.type = 'hidden';
          quantity.name = `items[${index}][quantity]`;
          quantity.value = '1';
          form.appendChild(quantity);
        });
        const redirect = document.createElement('input');
        redirect.type = 'hidden';
        redirect.name = 'return_to';
        redirect.value = '/cart';
        form.appendChild(redirect);
        document.body.appendChild(form);
        form.submit();
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azelia-sticky-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const widgets = document.querySelectorAll('[data-azelia-sticky-buy]');
    widgets.forEach((widget) => {
      if (widget.dataset.ready === 'true') return;
      widget.dataset.ready = 'true';

      const form = widget.querySelector('form[action*="/cart/add"]');
      const select = widget.querySelector('[data-sticky-variant]');
      const price = widget.querySelector('[data-sticky-price]');
      const image = widget.querySelector('.azelia-sticky-buy__image');
      const button = widget.querySelector('.azelia-sticky-buy__add');
      const buttonLabel = widget.querySelector('[data-sticky-add-label]');

      const refresh = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        if (!option) return;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (image && option.dataset.image) image.src = option.dataset.image;
        const available = option.dataset.available === 'true';
        if (button) button.disabled = !available;
        if (buttonLabel) buttonLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      };

      if (select) select.addEventListener('change', refresh);

      document.addEventListener('change', (event) => {
        const target = event.target;
        if (!select || !target || target.name !== 'id' || widget.contains(target)) return;
        const matchingOption = Array.from(select.options).find((option) => option.value === target.value);
        if (!matchingOption) return;
        select.value = target.value;
        refresh();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const primaryButton = document.querySelector('main product-form button[name="add"], main .product-form__submit');
      const showWidget = () => widget.classList.add('is-visible');
      const hideWidget = () => widget.classList.remove('is-visible');

      if (primaryButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) showWidget();
          else hideWidget();
        }, { threshold: 0 });
        observer.observe(primaryButton);
      } else {
        const toggle = () => {
          if (window.scrollY > 650) showWidget();
          else hideWidget();
        };
        window.addEventListener('scroll', toggle, { passive: true });
        toggle();
      }

      if (form) refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
